export default "__VITE_ASSET__49de201f__";